import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import UnifiedPage from "./pages/UnifiedPage";
import MappingPage from "./pages/MappingPage"; // MappingPage importieren

function App() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
console.log("📢 refreshTrigger in App.js:", refreshTrigger);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/all-in-one" element={<UnifiedPage refreshTrigger={refreshTrigger} setRefreshTrigger={setRefreshTrigger} />} />
        <Route path="/mapping" element={<MappingPage key={refreshTrigger} refreshTrigger={refreshTrigger} />} />
        <Route path="*" element={<Navigate to="/" />} /> {/* ⚡ Unbekannte Routen -> Home */}
      </Routes>
    </Router>
  );
}

export default App;

